// Delete Assignment
export const DELETE_ASSIGNMENT_REQUEST = 'DELETE_ASSIGNMENT_REQUEST';
export const DELETE_ASSIGNMENT_DONE = 'DELETE_ASSIGNMENT_DONE';
export const DELETE_ASSIGNMENT_FAILED = 'DELETE_ASSIGNMENT_FAILED';
